var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-block img-container",
      class: _vm.mainClasses,
      attrs: { id: `img-container-wrapper-${_vm.id}` },
    },
    [
      _c(
        "div",
        { staticClass: "row", class: [_vm.noSpaceBetween ? "no-gutters" : ""] },
        [
          _vm._l(_vm.items, function (img, idx) {
            return [
              _vm.lineBreak(idx) && !_vm.enableMainImage
                ? _c("div", { staticClass: "w-100" })
                : _vm._e(),
              _vm._v(" "),
              _c("FileContainer", {
                key: `key-${_vm.id}-${idx}`,
                ref: `imageInput${_vm.id}`,
                refInFor: true,
                staticClass: "col",
                class: _vm.imageClasses(idx),
                attrs: {
                  id: `img-container-${_vm.id}`,
                  idUpload: `image-upload-${_vm.id}-${idx + 1}`,
                  disabled: _vm.disabled,
                  fileIndex: idx,
                  maxFiles: _vm.maxImage,
                  multiple: _vm.multiple,
                  targetFile: _vm.photos[idx],
                  fileList: _vm.photos,
                  showLimitMessage: _vm.showImageLimitMessage,
                  showDeleteButton: _vm.activeDeleteButton,
                  showEditButton: _vm.activeEditButton,
                  accept: _vm.accept,
                  fileClass: _vm.imageClass,
                  capture: _vm.captureMediaAttribute,
                  filenameProperty: _vm.filenameProperty,
                  pathProperty: _vm.pathProperty,
                  typeProperty: _vm.typeProperty,
                },
                on: {
                  removeFile: _vm.onRemoveImage,
                  createImage: _vm.onCreateImage,
                  updateImage: _vm.onUpdateImage,
                  preview: _vm.onShowLightbox,
                },
              }),
              _vm._v(" "),
              _vm.lineBreak(idx) && !_vm.enableMainImage
                ? _c("div", { staticClass: "w-100" })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.lightBoxVisible
        ? _c("VueEasyLightbox", {
            attrs: {
              visible: _vm.openImage,
              index: _vm.imageIndex,
              imgs: _vm.arrLightBox,
              moveDisabled: false,
            },
            on: { hide: _vm.handleLightboxHide },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }